import api from '../../utils/axios';

export const searchTrain = async (trainNumber, journeyDate) => {
    try {
        const response = await api.post('/agent/tracking/train/search', {
            train_number: trainNumber,
            journey_date: journeyDate
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};
